import { useTranslation } from 'react-i18next';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import InputTranslateButton from 'components/desktop/_general/Input/InputExtensions/InputTranslateButton/InputTranslateButton';
import SimpleInput from 'components/desktop/_general/Input/SimpleInput/SimpleInput';
import useCultureCode from 'hooks/redux/useCultureCode';
import useLanguages from 'hooks/redux/useLanguages';
import { usePermissions } from 'hooks/usePermissions';
import { Language } from 'types/Language/Language';

interface IProps {
	text: string;
	handleValueChange: (input: { cultureCode: string; value: string }) => void;
	onTranslateClick: (name: string) => void;
	selectedLanguage: string;
}

const BaseIngredientLanguageInput = (props: IProps) => {
	const { t } = useTranslation();
	const { isBaseIngredientEditor } = usePermissions();
	const reduxLanguages: Language[] = useLanguages();
	const reduxCultureCode: string = useCultureCode();

	const handleValueChange = (value: string): void => {
		props.handleValueChange({ cultureCode: props.selectedLanguage, value: value });
	};

	const isTranslatable = (): boolean => {
		if (!isBaseIngredientEditor) return false;
		if (reduxLanguages && reduxCultureCode !== undefined) {
			if (reduxCultureCode === props.selectedLanguage) {
				return false;
			} else {
				return true;
			}
		}
		return false;
	};

	const renderContent = () => {
		return (
			<>
				<div className="row">
					<div className="col-12">
						<label>{t('_general:NAME')}</label>
						<div className="input-group">
							<SimpleInput
								disabled={!isBaseIngredientEditor}
								errorKey="NameTranslations"
								handleChange={handleValueChange}
								value={props.text}
							/>
							<RenderIf condition={isTranslatable()}>
								<InputTranslateButton
									name="nameTranslations"
									onClick={props.onTranslateClick}
								/>
							</RenderIf>
						</div>
					</div>
				</div>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default BaseIngredientLanguageInput;
